<template>
  <div>
    <h1>Spin Loader</h1>

    <div class="mb-base">
      <p class="mb-xs"><strong>Extra small spinner</strong></p>
      <SpinLoader size="extraSmall" />
    </div>

    <div class="mb-base">
      <p class="mb-xs"><strong>Small spinner</strong></p>
      <SpinLoader size="small" />
    </div>

    <div class="mb-base">
      <p class="mb-xs"><strong>Medium spinner</strong></p>
      <SpinLoader size="medium" />
    </div>

    <div class="mb-base">
      <p class="mb-xs"><strong>Large spinner</strong></p>
      <SpinLoader size="large" />
    </div>

    <div class="mb-base">
      <p class="mb-xs"><strong>Extra large spinner</strong></p>
      <SpinLoader size="extraLarge" />
    </div>
  </div>
</template>

<script>
import SpinLoader from '@/components/library/loaders/SpinLoader.vue';

export default {
  components: { SpinLoader },
};
</script>

<style>
</style>
